import React from 'react';
import { connect } from 'react-redux';
import Link from 'next/link';
import { setupMapBounds } from '../../../actions/feed';
import { LocationDetailType } from '../../../lib/constants';

import styles from '../../../styles/sass/components/PopularSearches.module.scss';

interface Props {
  dispatch: any;
  popularSearches: LocationDetailType[];
  searchState: 'MA' | undefined;
}

export function PopularSearches(props: Props) {
  const { dispatch, popularSearches, searchState } = props;
  const locationDisplay = {
    MA: 'Massachusetts',
  };

  const searchLocation = (lat: number, lng: number, name: string) => {
    const valuesToSubmit = {
      location: `${lat},${lng}`,
      locationName: name,
    };
    dispatch(setupMapBounds(valuesToSubmit));
  };

  const renderPopularSearches = (popularSearches: LocationDetailType[]) => {
    return popularSearches.map((searchItem: LocationDetailType) => {
      return (
        <p key={searchItem.id} className={styles.linkTextStyle}>
          <Link
            href={{
              pathname: '/search',
              query: { location: `${searchItem.lat},${searchItem.lng}` },
            }}
          >
            <a
              onClick={() => {
                searchLocation(
                  searchItem.lat,
                  searchItem.lng,
                  searchItem.locationName,
                );
              }}
            >
              {searchItem.locationName} Homes for Sale
            </a>
          </Link>
        </p>
      );
    });
  };
  return (
    <div className={`col-xs-12 ${styles.popularSearchContainer}`}>
      <React.Fragment>
        <p className={`${styles.textStyle} ${styles.bold}`}>
          How often does Torii update its listings?
        </p>
        <p className={styles.textStyle}>
          Torii is refreshed with the newest listings in
          {searchState ? ` ${locationDisplay[searchState]} ` : ' '}every 15
          minutes or less.
        </p>
        <p className={`${styles.textStyle} ${styles.bold}`}>
          Popular Searches:
        </p>
        {renderPopularSearches(popularSearches)}
      </React.Fragment>
      <br />
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default connect(null, mapDispatchToProps)(PopularSearches);
